import {
  QUICK_LOGIN,
  USER_LOGIN,
  AGENT_DETAIL_GET,
  USER_ACCOUNT_GET,
  GET_OPERATE_TOKEN,
  USER_INFO_GET,
  VCODE_GET,
  COMMON_ROLE_PRODUCT_MANAGER_GET,
} from "../../fetch/url";
import { post, get } from "../../fetch/fetch";
import { actionTypes } from "./constants";
import { curl } from "zh-common-modules";
import { clearAllCookie, pathPrefix } from 'src/util';
import { setCurMenu, setCurrMenuPath, setCurUrl } from "../global/actionCreators";
import { setCart } from 'src/store/cart/actionCreators';
// import {userState} from 'src/util/util';

export const setUserNoticeTag = (data) => ({
  type: actionTypes.SET_USER_AUDIT_NOTICE_TAG,
  data,
});

export const saveUserInfo = (data) => ({
  type: actionTypes.USER_LOGIN,
  data,
});

export const setManagerAccount = (data) => ({
  type: actionTypes.SET_MANAGER_ACCOUNT,
  data,
});

export const setCompanyInfo = (data) => ({
  type: actionTypes.SET_COMPANY_INFO,
  data,
});

export const setLoginToken = (data) => ({
  type: actionTypes.SET_LOGIN_TOKEN,
  data,
});

export const setMessage = (data) => ({
  type: actionTypes.SET_MESSAGE,
  data,
});

export const resetUserInfo = (data) => ({
  type: actionTypes.LOGOUT,
  data,
});

export const setVcode = (data) => ({
  type: actionTypes.SET_VCODE,
  data,
});

export const setUserInfo = (data) => ({
  type: actionTypes.SET_USER_INFO,
  data,
});

export const setAllProductManager = (data) => ({
  type: actionTypes.SET_ALL_PRODUCT_MANAGER,
  data,
});

export const setAllProductManagerFormat = (data) => ({
  type: actionTypes.SET_ALL_PRODUCT_MANAGER_FORMAT,
  data,
});

export const logout = (data) => {
  return (dispatch) => {
    dispatch(setCart({ cart: [] }));
    dispatch(resetUserInfo());
    dispatch(setCurUrl({ url: pathPrefix + '/login' }));
    setTimeout(() => {
      window.location.href = pathPrefix + "/login";
      clearAllCookie();
    }, 200);
  };
};

export const getLoginToken = (data) => {
  return (dispatch) => {
    get(GET_OPERATE_TOKEN, { uid: data.uid })
      .then((res) => {
        dispatch(setLoginToken(res.content.token));
      })
      .catch(() => {
      });
  };
};

export const getManagerAccount = (data) => {
  return (dispatch) => {
    get(USER_ACCOUNT_GET, { id: data.id })
      .then((res) => {
        dispatch(setManagerAccount(res.content));
      })
      .catch(() => {
        dispatch(
          setMessage({
            type: "error",
            msg: "获取账号信息失败！",
          })
        );
      });
  };
};

export const getCompanyInfo = (data) => {
  return (dispatch) => {
    get(AGENT_DETAIL_GET, { id: data.id })
      .then((res) => {
        dispatch(setCompanyInfo(res.content));
      })
      .catch(() => {
        dispatch(
          setMessage({
            type: "error",
            msg: "获取公司信息失败！",
          })
        );
      });
  };
};

export const quickLogin = (data, cb) => {
  return (dispatch) => {
    post(QUICK_LOGIN, { token: data.token })
      .then((res) => {
        if (res.success) {
          const user = res.content;
          dispatch(saveUserInfo(user));
          cb && cb();
        } else {
          dispatch(setMessage({
            type: 'error',
            msg: res.message,
          }));
        }
      })
      .catch(() => {
        dispatch(
          setMessage({
            type: "error",
            msg: "登录失败！",
          })
        );
      });
  };
};

export const getVcode = () => {
  return (dispatch) => {
    get(VCODE_GET)
      .then((res) => {
        res.content.img = res.content.img
          .replace("150", "100%")
          .replace("50", "100%");
        dispatch(setVcode(res.content));
        dispatch(setCurMenu(0));
        dispatch(setCurrMenuPath(pathPrefix + '/main/index'));
      })
      .catch(() => {
      });
  };
};

export const getUserInfo = (data) => {
  return (dispatch) => {
    get(USER_INFO_GET, data)
      .then(res => {
        if (res.success) {
          const user = res.content;
          dispatch(setUserInfo(user));
        } else {
          dispatch(setMessage({
            type: 'error',
            msg: res.message,
          }));
          return;
        }
      })
      .catch(() => {
        dispatch(setMessage({
          type: 'error',
          msg: '更新用户信息失败！',
        }));
      });
  };
};

export const login = (data) => {
  return (dispatch) => {
    post(USER_LOGIN, data)
      .then(res => {
        if (res.success) {
          const user = res.content;
          dispatch(saveUserInfo(user));
        } else {
          dispatch(setMessage({
            type: 'error',
            msg: res.message,
          }));
          return;
        }
      })
      .catch(() => {
        dispatch(setMessage({
          type: 'error',
          msg: '登录失败！',
        }));
      });

    // const user = {
    //   id: "123",
    //   name: "测试专用代理商",
    //   status: "",
    //   phone: "13111111111",
    //   roleName: "代理商",
    //   privileges: [
    //     {
    //       id: 1,
    //       key: "/main/usercenter/usercenter/account",
    //       type: "READ",
    //       name: "账号信息",
    //     },
    //   ],
    //   category: "ADMIN",
    //   firstLogin: 0,
    // };
    // dispatch(saveUserInfo(user));
  };
};

export const getAllProductManager = () => {
  return (dispatch) => {
    curl
      .get(COMMON_ROLE_PRODUCT_MANAGER_GET)
      .then((res) => {
        const format = res.map(_item => {
          const { account } = _item;
          return ({ ..._item, ...account });
        });
        dispatch(setAllProductManager(res));
        dispatch(setAllProductManagerFormat(format));
      });
  };
};

